import { formatDistanceToNowStrict, format } from 'date-fns';
import { DATE_FORMATS } from '@/consts/date.consts';

export const getTimeDiffInWords = (time: Date | number) => formatDistanceToNowStrict(time, { addSuffix: true });

export const formatInGMT = (date: Date, formatString: string): string => {
  // Shift date by timezone offset so format() displays UTC time
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  return format(utcDate, formatString);
};

export const startOfGMTDay = (date: Date): Date => {
  const result = new Date(date);
  result.setUTCHours(0, 0, 0, 0);
  return result;
};

export const formatLocaleDate = (iso: string): string => new Date(iso).toLocaleDateString();

export const formatLongDate = (iso: string): string => format(new Date(iso), DATE_FORMATS.DATE);

export const formatShortDateTime = (iso: string): string => format(new Date(iso), DATE_FORMATS.SHORT_DATE_TIME);
